/**
 * WEB-3447 — ЛЕНИВЫЙ КУСОК рамки экрана эталона Slimkit (пачка настроек 2,
 * перенос WEB-3128): шапка «узлы по разделам», шевроны «назад» и «вперёд»,
 * прибитая шапка, прибитая нижняя кнопка и её вид из пака, пауза перехода по
 * кнопкам, лого слева на компьютере.
 *
 * Здесь нет своего кода — только набор прежних функций и компонентов одним
 * объектом. Визард (`QuizScreenWizard.tsx`) берёт его у двери
 * `quizChromeKitDoor.ts`: покупатель получает этот файл, только когда пак
 * воронки рамку включает (`packNeedsQuizChromeKit`), прочим воронкам
 * достаётся лёгкий запасной набор той же формы.
 *
 * Импортировать этот файл статически можно только кабинету (`main.tsx`) и
 * тестам: статический импорт из плеера вернул бы рамку в первый экран — это
 * краснит `FIRST_SCREEN_DEFERRED_MODULES` сторожа сборки.
 */
import { useQuizChromeExtras } from './useQuizChromeExtras';
import { QuizSectionHeader, ForwardChevronButton } from './QuizSectionHeader';
import { sectionProgressForVisitor } from './sectionProgress';
import {
  ChevronIcon,
  CHEVRON_BOX_STYLE,
  chevronSlotStyle,
  ArrowBackIcon,
  CIRCLE_SOLID_STYLE,
} from './chromeIcons';
import { CtaDock } from './CtaDock';
import { ctaPackButtonStyle, DOCKED_WRAP_STYLE } from './ctaDockStyle';
import { QuizChromeFrame } from './QuizChromeFrame';
import { DesktopLogo } from './DesktopLogo';
import { QuizCloseButton } from './QuizCloseButton';
import { QuizSectionStepsProgress } from './QuizSectionStepsProgress';

export const QUIZ_CHROME_KIT = {
  useQuizChromeExtras,
  QuizSectionHeader,
  ForwardChevronButton,
  sectionProgressForVisitor,
  ChevronIcon,
  CHEVRON_BOX_STYLE,
  chevronSlotStyle,
  CtaDock,
  ctaPackButtonStyle,
  DOCKED_WRAP_STYLE,
  QuizChromeFrame,
  DesktopLogo,
  // Слово владельца 20.10.2026: крестик «закрыть» шапки квиза своим полем.
  QuizCloseButton,
  // Дополнение того же слова: круг со стрелкой «назад» без текста (circle-solid).
  ArrowBackIcon,
  CIRCLE_SOLID_STYLE,
  // Слово владельца 21.10.2026 (Blinkist): шаги-разделы шапки своим полем.
  QuizSectionStepsProgress,
};
